import type { SVGProps } from 'react'

interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> {
  size?: number
}

function IconRoot({
  size = 24,
  viewBox,
  children,
  ...rest
}: IconProps & { viewBox: string; children: React.ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      {...rest}
    >
      {children}
    </svg>
  )
}

export function TranslateTextIcon(props: IconProps) {
  return (
    <IconRoot viewBox="0 0 36 37" {...props}>
      <path
        d="M33 0H3C1.34009 0 0 1.33997 0 3V33.0399C0 34.6901 1.34009 36.0399 3 36.0399H33C34.6499 36.0399 36 34.6901 36 33.0399V3C36 1.33997 34.6499 0 33 0ZM25.49 27.62C25.22 27.8199 24.8999 27.92 24.5901 27.92C24.1301 27.92 23.6899 27.72 23.3901 27.33L17.6602 19.7999L15.6899 17.2001C13.51 18.51 12.96 22.83 12.9102 26.4501C12.8901 27.27 12.22 27.92 11.4102 27.92H11.3801C10.55 27.91 9.89014 27.23 9.91016 26.4C10.01 20.2999 11.3 16.47 13.8601 14.7899L10.6101 10.52C10.1101 9.85999 10.24 8.92004 10.8999 8.42004C11.5601 7.92004 12.5 8.04993 13 8.71008L17.3301 14.41C17.3901 14.47 17.45 14.5499 17.49 14.62L19.3901 17.11C21.0901 16.2899 22.6699 14.5 22.48 9.67004C22.45 8.84998 23.0901 8.15002 23.9199 8.10999C24.74 8.09998 25.45 8.72998 25.48 9.54993C25.6699 14.4401 24.24 17.78 21.22 19.52L25.78 25.51C26.28 26.17 26.1499 27.11 25.49 27.62Z"
        fill="currentColor"
      />
    </IconRoot>
  )
}

export function PDFIcon(props: IconProps) {
  return (
    <IconRoot viewBox="0 0 32 40" {...props}>
      <path
        d="M29 18.99H19C15.69 18.99 13 16.3 13 12.99V3C13 1.34003 11.66 0 10 0H3C1.34003 0 0 1.34003 0 3V37C0 38.66 1.34003 40 3 40H29C30.65 40 32 38.65 32 37V21.99C32 20.33 30.66 18.99 29 18.99ZM16 12.9899V2.41411C16 1.52321 17.0771 1.07704 17.7071 1.70701L30.2829 14.2828C30.9129 14.9128 30.4667 15.9899 29.5758 15.9899H19C17.35 15.9899 16 14.6499 16 12.9899Z"
        fill="currentColor"
      />
      <path
        d="M6.51001 22.6H16.36C17.19 22.6 17.86 23.27 17.86 24.1C17.86 24.93 17.19 25.6 16.36 25.6H6.51001C5.67999 25.6 5.01001 24.93 5.01001 24.1C5.01001 23.27 5.67999 22.6 6.51001 22.6ZM25.49 36.43H6.51001C5.67999 36.43 5.01001 35.76 5.01001 34.93C5.01001 34.1 5.67999 33.43 6.51001 33.43H25.49C26.32 33.43 26.99 34.1 26.99 34.93C26.99 35.76 26.32 36.43 25.49 36.43ZM25.49 31.02H6.51001C5.67999 31.02 5.01001 30.34 5.01001 29.52C5.01001 28.69 5.67999 28.02 6.51001 28.02H25.49C26.32 28.02 26.99 28.69 26.99 29.52C26.99 30.34 26.32 31.02 25.49 31.02Z"
        fill="currentColor"
      />
    </IconRoot>
  )
}

export function ImageIcon(props: IconProps) {
  return (
    <IconRoot viewBox="0 0 48 48" {...props}>
      <path
        d="M41 14.3H36.93C35.93 14.3 35 13.8098 34.44 12.98L31.99 9.32983C31.43 8.5 30.5 8 29.5 8H18.51C17.51 8 16.58 8.5 16.02 9.32983L13.57 12.98C13.01 13.8098 12.08 14.3 11.08 14.3H7C5.34003 14.3 4 15.6499 4 17.3V37C4 38.6599 5.34003 40 7 40H41C42.66 40 44 38.6599 44 37V17.3C44 15.6499 42.66 14.3 41 14.3ZM24 35.6299C19.53 35.6299 15.91 32.01 15.91 27.55C15.91 23.0798 19.53 19.46 24 19.46C28.47 19.46 32.09 23.0798 32.09 27.55C32.09 32.01 28.47 35.6299 24 35.6299Z"
        fill="currentColor"
      />
    </IconRoot>
  )
}

export function VoiceIcon(props: IconProps) {
  return (
    <IconRoot viewBox="0 0 40 33" {...props}>
      <path
        d="M15.461 4.97903V29.1109C15.461 29.9832 14.4221 30.4373 13.7818 29.8448L7.36761 23.9094C7.18279 23.7384 6.94026 23.6434 6.68845 23.6434H2C0.89543 23.6434 0 22.748 0 21.6434V12.4465C0 11.3419 0.89543 10.4465 2 10.4465H6.68845C6.94026 10.4465 7.18279 10.3515 7.36761 10.1805L13.7818 4.24506C14.4221 3.65258 15.461 4.10669 15.461 4.97903Z"
        fill="currentColor"
      />
      <path
        d="M19.9771 22.7324C19.4664 22.7324 18.9683 22.4717 18.6881 22.001C18.2633 21.2891 18.4967 20.3692 19.2076 19.9444C20.606 19.1104 21.441 17.6377 21.441 16.0059C21.441 14.375 20.606 12.9024 19.2076 12.0684C18.4967 11.6436 18.2633 10.7236 18.6881 10.0117C19.1119 9.29982 20.0328 9.06837 20.7447 9.4922C23.025 10.8526 24.441 13.3486 24.441 16.0059C24.441 18.6641 23.025 21.1602 20.7447 22.5205C20.5035 22.6641 20.2388 22.7324 19.9771 22.7324Z"
        fill="currentColor"
      />
      <path
        d="M26.065 27.4076C25.6324 27.4076 25.2037 27.222 24.9068 26.8626C24.3794 26.224 24.4703 25.2777 25.1089 24.7503C27.7164 22.599 29.2115 19.4115 29.2115 16.0062C29.2115 12.6136 27.7154 9.42612 25.106 7.2601C24.4683 6.7308 24.3804 5.78549 24.9097 5.14779C25.44 4.5101 26.3843 4.42318 27.022 4.9515C30.3199 7.68978 32.2115 11.7191 32.2115 16.0062C32.2115 20.3099 30.3189 24.3412 27.0191 27.0648C26.7398 27.2953 26.4009 27.4076 26.065 27.4076Z"
        fill="currentColor"
      />
      <path
        d="M32.0836 32.0128C31.6773 32.0128 31.2711 31.8477 30.9752 31.5235C30.4176 30.9112 30.4605 29.963 31.0728 29.4044C34.8277 25.9786 36.982 21.0948 36.982 16.006C36.982 10.9308 34.8277 6.04696 31.0709 2.60654C30.4595 2.04696 30.4176 1.09775 30.9771 0.487394C31.5377 -0.12491 32.4888 -0.164949 33.0963 0.393644C37.4722 4.40146 39.982 10.0909 39.982 16.006C39.982 21.9366 37.4713 27.628 33.0943 31.6212C32.8072 31.8829 32.4449 32.0128 32.0836 32.0128Z"
        fill="currentColor"
      />
    </IconRoot>
  )
}

export function MobileSendIcon(props: IconProps) {
  return (
    <IconRoot viewBox="0 0 36 36" {...props}>
      <path
        d="M33.2586 0.164405L1.18779 13.909C-0.400378 14.5896 -0.394565 16.8432 1.19709 17.5156L10.1533 21.2995C10.6515 21.51 11.2246 21.4343 11.6511 21.1018L20.0307 14.5693C20.9551 13.8487 22.1472 15.041 21.4266 15.9652L14.8877 24.352C14.5549 24.7788 14.4794 25.3523 14.6903 25.8507L18.4796 34.804C19.1528 36.3947 21.4053 36.3998 22.0857 34.8122L35.8319 2.73774C36.5288 1.11166 34.8847 -0.532488 33.2586 0.164405Z"
        fill="currentColor"
      />
    </IconRoot>
  )
}

export function MobileStarIcon(props: IconProps) {
  return (
    <IconRoot viewBox="0 0 37 36" {...props}>
      <path
        d="M20.3483 1.24004L23.9622 10.0375C24.2496 10.7371 24.907 11.2147 25.6611 11.2718L35.1448 11.9903C36.9271 12.1254 37.6507 14.3523 36.2881 15.5092L29.038 21.6648C28.4615 22.1543 28.2104 22.9271 28.3891 23.662L30.6364 32.9036C31.0588 34.6404 29.1644 36.0167 27.6431 35.0783L19.5483 30.0853C18.9046 29.6882 18.092 29.6882 17.4483 30.0853L9.35357 35.0783C7.83225 36.0167 5.93787 34.6404 6.36022 32.9036L8.60748 23.662C8.78618 22.9271 8.53507 22.1543 7.95855 21.6648L0.70843 15.5092C-0.654148 14.3523 0.0694563 12.1254 1.8518 11.9903L11.3354 11.2718C12.0896 11.2147 12.747 10.7371 13.0344 10.0375L16.6483 1.24004C17.3275 -0.413346 19.6691 -0.413346 20.3483 1.24004Z"
        fill="currentColor"
      />
    </IconRoot>
  )
}

export function SettingsGearIcon(props: IconProps) {
  return (
    <IconRoot viewBox="0 0 38 40" {...props}>
      <path
        d="M32.6542 20C32.6542 19.3281 32.6134 18.6562 32.5161 17.9998C32.4597 17.6192 32.6064 17.24 32.9213 17.019L37.1163 14.0742C37.49 13.8119 37.6486 13.3253 37.4834 12.8997C36.6993 10.8787 35.6206 9.00472 34.284 7.35188C33.998 6.99823 33.4993 6.89476 33.0868 7.08627L28.4077 9.25853C28.0604 9.41976 27.6581 9.36083 27.3582 9.1228C26.3271 8.30453 25.1786 7.62077 23.944 7.14847C23.582 7.01 23.3219 6.69183 23.2864 6.30589L22.8129 1.15436C22.7714 0.703377 22.4349 0.32728 21.9876 0.256683C20.9423 0.0917347 19.8603 0 18.7784 0C17.6959 0 16.6139 0.0917427 15.5685 0.256699C15.1211 0.327293 14.7846 0.703429 14.7431 1.15445L14.27 6.30585C14.2345 6.69181 13.9744 7.01 13.6124 7.14848C12.3777 7.62079 11.2293 8.30454 10.1982 9.1228C9.8983 9.36083 9.496 9.41976 9.1487 9.25853L4.46327 7.08331C4.05374 6.89319 3.55824 6.99354 3.27116 7.34204C1.90657 8.99865 0.824165 10.8778 0.061417 12.9048C-0.0979751 13.3283 0.0623364 13.8093 0.432755 14.0693L4.63466 17.019C4.94959 17.24 5.09635 17.6192 5.03993 17.9998C4.94265 18.6562 4.90178 19.3281 4.90178 20C4.90178 20.6719 4.94265 21.3438 5.03993 22.0002C5.09635 22.3808 4.94959 22.76 4.63466 22.981L0.432816 25.9306C0.0623724 26.1907 -0.0980038 26.6717 0.0614475 27.0953C0.825942 29.1262 1.91357 31.0087 3.30547 32.6676C3.59358 33.011 4.08584 33.1083 4.49242 32.9196L9.17018 30.7479C9.52463 30.5834 9.93425 30.6502 10.2361 30.8984C11.2424 31.7258 12.3823 32.3872 13.6101 32.852C13.9735 32.9896 14.2346 33.3091 14.2701 33.696L14.7431 38.8456C14.7846 39.2966 15.1211 39.6727 15.5685 39.7433C16.6139 39.9083 17.6959 40 18.7784 40C19.8603 40 20.9423 39.9083 21.9876 39.7433C22.4349 39.6727 22.7714 39.2966 22.8129 38.8456L23.2863 33.6952C23.3218 33.3087 23.583 32.9897 23.9458 32.8517C25.172 32.3853 26.2969 31.7212 27.3204 30.8901C27.6212 30.6458 28.0289 30.5821 28.3804 30.7452L33.0578 32.9167C33.4673 33.1068 33.9627 33.0065 34.2498 32.658C35.6135 31.0028 36.6974 29.1254 37.4834 27.1004C37.6486 26.6747 37.4899 26.1881 37.1163 25.9258L32.9213 22.981C32.6064 22.76 32.4597 22.3808 32.5161 22.0002C32.6134 21.3438 32.6542 20.6719 32.6542 20ZM18.7784 27.0442C14.893 27.0442 11.7478 23.9077 11.7339 20.0259C11.7205 16.299 14.7883 13.1001 18.5127 12.9608C22.4888 12.8121 25.8226 16.0172 25.8226 20C25.8226 23.8937 22.6363 27.0442 18.7784 27.0442Z"
        fill="currentColor"
      />
    </IconRoot>
  )
}

export function HistoryClockIcon(props: IconProps) {
  return (
    <IconRoot viewBox="0 0 48 48" {...props}>
      <path
        d="M24 4C12.96 4 4 12.96 4 24C4 35.04 12.96 44 24 44C35.04 44 44 35.04 44 24C44 12.96 35.04 4 24 4ZM31.3 31.3C30.9 31.7 30.39 31.9 29.88 31.9C29.37 31.9 28.86 31.7 28.47 31.3L22.5 25.33C22.19 25.02 22 24.59 22 24.14V13C22 12.17 22.67 11.5 23.5 11.5C24.33 11.5 25 12.17 25 13V23.52L30.59 29.11C31.17 29.69 31.17 30.64 30.59 31.22L31.3 31.3Z"
        fill="currentColor"
      />
    </IconRoot>
  )
}
